module.exports = __webpack_public_path__ + "img/img-logo-podium.3562d528.svg";